//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'CCountDownButton',

  props: {
    countSize: {
      type: Number,
      default: 60,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    text: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      innerDisabled: false,
      countNum: 0,
    }
  },

  methods: {
    countDown () {
      this.countNum = this.countSize

      if (this.innerDisabled) {
        return
      }

      this.innerDisabled = true
      this.inter = setInterval(() => {
        if (this.countNum > 0) {
          this.countNum--
        } else {
          this.innerDisabled = false
          this.countNum = 60

          clearInterval(this.inter)
        }
      }, 1000)
    },

    reset () {
      this.innerDisabled = false
      this.countNum = 60

      clearInterval(this.inter)
    },
  },
}
